import moment from "moment";
import {
  OperatorContactData,
  OperatorFinanceData,
  OperatorSummary,
} from "@/api/dtos/Operator.schema";
import {
  StationLocation,
  Address,
  Pricing,
  Station,
  StationSupportContacts,
  Card,
  DeviceDimensions,
  Device,
  DeviceTypeSettings,
  DeviceTypeDescription,
  DevicePropertyDescription,
} from "@/api/dtos/Station.schema";
import { DeviceHardwareSettings } from "@/api/dtos/DeviceHardwareSettings.schema";
import { set } from "vue/types/umd";
// GENERAL

export function getAddressDummy(): Address {
  const address: Address = {} as Address;
  address.city = "";
  address.country = "DE";
  address.postalCode = "";
  address.street = "";
  return address;
}

// STATION

export function getStationLocationDummy(): StationLocation {
  const stationLocation: StationLocation = {} as StationLocation;
  stationLocation.address = getAddressDummy();
  stationLocation.lat = 0;
  stationLocation.lon = 0;
  stationLocation.stationName = "";
  return stationLocation;
}

export function getPricingDummy(): Pricing {
  const price: Pricing = {} as Pricing;
  price.deviceProperties = [];
  price.deviceType = "SINGLE";
  price.pricePerDayEuros = 0;
  price.pricePerHourEuros = 0;
  price.pricePerMinuteEuros = 0;
  price.pricePerMonthEuros = 0;
  price.pricePerWeekEuros = 0;
  price.pricePerYearEuros = 0;
  price.uuid = "";
  return price;
}

export function getStationSupportContactsDummy(): StationSupportContacts {
  const support: StationSupportContacts = {} as StationSupportContacts;
  support.serviceEmail = "";
  support.servicePhone = "";
  return support;
}

export function getCardDummy(): Card {
  const card: Card = {} as Card;
  card.isServiceCard = false;
  card.name = "";
  card.uid = "";
  return card;
}

export function getDeviceHardwareSettingsDummy(): DeviceHardwareSettings {
  // TODO from number
  const settings: DeviceHardwareSettings = {
    hardwareType: "BIKE_PARK_BOX",
    wts04Out: {
      wts04: "WTS00",
      wts04OutPort: "OUT1",
      openDelay: moment.duration(1, "seconds").toISOString(),
      openDuration: moment.duration(5, "seconds").toISOString()
    },
    wts04In: null
  };
  return settings;
}

export function getDeviceDimensionsDummy(deviceType: string): DeviceDimensions {
  const dimensions: DeviceDimensions = {} as DeviceDimensions;
  switch (deviceType) {
    case "SINGLE":
      dimensions.length = 1.9;
      dimensions.height = 1.1;
      dimensions.width = 0.6;
      break;
    case "GROUP":
      dimensions.length = 5;
      dimensions.height = 2;
      dimensions.width = 10;
      break;
    case "LOCKER":
      dimensions.length = 0.3;
      dimensions.height = 0.3;
      dimensions.width = 0.3;
      break;
    default:
      dimensions.length = 1;
      dimensions.height = 1;
      dimensions.width = 1;
      break;
  }
  return dimensions;
}

export function getDeviceTypeSettingsDummy(
  deviceType: string
): DeviceTypeSettings {
  const settings: DeviceTypeSettings = {} as DeviceTypeSettings;
  settings.assignedProperties = [];
  settings.assignedType = deviceType;
  return settings;
}

export function getDeviceDummy(deviceType: string): Device {
  const device: Device = {} as Device;
  device.deviceNumber = 1;
  device.rentalMethod = "PUBLIC";
  device.typeSettings = getDeviceTypeSettingsDummy(deviceType);
  device.capacity = 1;
  device.descriptionText = "";
  device.dimensions = getDeviceDimensionsDummy(deviceType);
  device.hardwareSettings = getDeviceHardwareSettingsDummy();
  device.maxPrebookDuration = moment.duration(30, "days").toISOString(); // TODO no default value was defined, maybe 1 month?
  device.maxRentalDuration = moment.duration(365, "days").toISOString();
  device.deviceStates = [];
  return device;
}

export function getDeviceTypeDescriptionDummy(): DeviceTypeDescription {
  const description: DeviceTypeDescription = {} as DeviceTypeDescription;
  description.deviceType = "SINGLE";
  description.description = "";
  return description;
}

export function getStationDummy(): Station {
  const station: Station = {} as Station;
  station.uuid = "";
  station.isActive = false; // TODO consider active = true
  station.platformServiceActive = false;
  station.devicePropertyDescriptions = [];
  station.deviceTypeDescriptions = [getDeviceTypeDescriptionDummy()];
  station.devices = [getDeviceDummy("SINGLE")];
  station.contactData = getStationSupportContactsDummy();
  station.stationLocation = getStationLocationDummy();
  station.pricingModels = [getPricingDummy()];
  station.operator = getOperatorSummaryDummy();
  station.serviceCards = [getCardDummy()];
  return station;
}

// OPERATOR

export function getOperatorContactDataDummy(): OperatorContactData {
  const contact: OperatorContactData = {} as OperatorContactData;
  contact.address = getAddressDummy();
  contact.archiveEmail = "";
  contact.defaultBookingEmail = "";
  contact.name = "";
  contact.shouldReceiveBookingNotifications = false;
  return contact;
}

export function getOperatorFinanceDataDummy(): OperatorFinanceData {
  const finance: OperatorFinanceData = {} as OperatorFinanceData;
  finance.IBAN = "";
  finance.payPalClientId = "";
  finance.payPalClientSecret = "";
  finance.salesTaxRate = 0;
  finance.usePayPalSandbox = false;
  finance.ustId = "";
  finance.ustNr = "";
  return finance;
}

export function getOperatorSummaryDummy(): OperatorSummary {
  return {
    uuid: "",
    name: "",
    platformServiceActive: false,
    managers: [],
    owners: [],
  };
}
